/**
 * Función para crear capas de tipo XYZ y OSM
 * @returns {TileLayer} Capa de tipo Tile
 */

import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import * as olSource from 'ol/source'

export function layerTile(props) {
    let layerSource = null
    const {
        source,
        name,
        title,
        image,
        type,
        visible = false,
        url,
        attributions = false,
        order,
        opacity = 1.0,
        queryable = true,
        tematica = false,
        group = null,
        minZoom = null,
        maxZoom = null,
    } = props;

    switch (source) {
        case 'olSource':
            layerSource = new olSource.OSM({
                crossOrigin: 'anonymous',
                attributions: attributions || undefined,
            })
            break

        case 'xyz':
            layerSource = new XYZ({
                url,
                tileSize: 256,
                crossOrigin: 'anonymous',
                attributions: attributions || undefined,
            })
            break
    }

    // Build layer options
    const layerOptions = {
        name,
        visible,
        image,
        title,
        source: layerSource,
        type,
        zIndex: order,
        queryable,
        tematica,
        opacity,
        group,
        preload: 8, // Preload adjacent tiles (default is 0)
    };

    // Only add minZoom/maxZoom if they are valid numbers
    if (minZoom !== null && minZoom !== undefined && !isNaN(Number(minZoom))) {
        layerOptions.minZoom = Number(minZoom);
    }
    // For XYZ/OSM layers, default to 19 if no maxZoom is specified
    if (maxZoom !== null && maxZoom !== undefined && !isNaN(Number(maxZoom))) {
        layerOptions.maxZoom = Number(maxZoom);
    } else {
        layerOptions.maxZoom = 19; // Default limit for tile layers
    }

    const tileLayer = new TileLayer(layerOptions);
    return tileLayer;
}
